
import { Component, Prop, Vue } from 'vue-property-decorator';
import { blobDownload, emptyUUID } from '../../../util';
import { GroupSurveyExtension, VisitorManagementUiClient } from '../../backend/backendapi';
import { handleError, initClient } from '../../../api';
import Toasted from 'vue-toasted';
import GroupSurveyExtensionStore from '../../../stores/GroupSurveyExtensionStore';
import Spinner from '../../util/Spinner';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    Spinner,
  },
})
export default class PrintBadgeButton extends Vue {
  @Prop({ required: true })
  readonly groupSurveyExtensionId!: string;
  @Prop({ required: true })
  readonly groupUserExternalId!: string;

  private readonly visitorApi = initClient(VisitorManagementUiClient);
  readonly store = new GroupSurveyExtensionStore();

  GroupSurveyExtension = GroupSurveyExtension;
  emptyUUID = emptyUUID;

  printingBadge = false;

  get canPrint(): boolean {
    return !!this.groupUserExternalId && this.groupUserExternalId !== emptyUUID()
        && !!this.groupSurveyExtensionId && this.groupSurveyExtensionId !== emptyUUID();
  }

  async printBadge(): Promise<void> {
    this.printingBadge = true;
    try {
      const response = await this.visitorApi.printBadge(this.groupSurveyExtensionId, this.groupUserExternalId);
      blobDownload(response.data, response.fileName ?? 'badge.pdf');
    } catch (err) {
      handleError(this.$toasted, this.$i18n, err);
    } finally {
      this.printingBadge = false;
    }
  }
}
